import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'

export const AppStoreParamsSchema = z.object({
  ios: z.string().optional(),
  android: z.string().optional(),
})
export type AppStoreParams = z.infer<typeof AppStoreParamsSchema>

export function useAppStoreParamsParameterStore() {
  return useMesaParameterStore('app_store_params')
}
